__turbopack_context__.v({
  "container": "AuthorBannerSection-module__8awTZG__container",
});
